module.exports = "/_next/static/images/c2d28a574f18fb6ca9aa586b5d593cf8-logo-cnn.png";